import React from 'react';
import MediaQuery from 'react-responsive';
import breakpoints from './breakpoints';

export default function DesktopBreakpoint(props) {    
    return <MediaQuery query={`(min-width: ${breakpoints.desktop}px)`}>{props.children}</MediaQuery>;
}
